import React from 'react';
import {observer} from "mobx-react";
import classNames from "classnames";
import styles from "../styles/news-widget.module.scss";
import {NewsImageRequestParams} from "../models/assets/news.image.request-params";
import {SVGImage} from "../../../core/components/image/svg-image";
import {useThemeColor} from "../../../infrastructure/hooks/useThemeColor";
import {COLORS} from "../../../core/app/consts/colors";

export const NewsWidgetEmptyState = observer(({controller}) => {
  const {state} = controller;
  const {shouldRenderEmptyState, emptyStateText} = state;

  const imageProps = {
    src: new NewsImageRequestParams(),
    className: classNames(styles.empty_state_logo),
    fillcolor: useThemeColor(COLORS.textSecondary)
  }

  return shouldRenderEmptyState ? <div className={classNames(styles.empty_state)}>
    <SVGImage {...imageProps}/>
    <div className={classNames(styles.empty_state_text)}>{emptyStateText}</div>
  </div> : null
});
